export const categories = [
  { slug: "hot", name: "热门吃瓜", icon: "ri-fire-line" },
  { slug: "entertainment", name: "娱乐圈", icon: "ri-movie-line" },
  { slug: "social", name: "社会热点", icon: "ri-global-line" },
  { slug: "emotion", name: "情感八卦", icon: "ri-heart-line" },
  { slug: "funny", name: "搞笑趣闻", icon: "ri-emotion-laugh-line" },
  { slug: "bizarre", name: "奇闻异事", icon: "ri-lightbulb-flash-line" },
];

export const mockVideos = [
  {
    id: "v1",
    title: "某知名艺人深夜密会神秘女子，全程被拍细节曝光",
    slug: "celebrity-secret-date",
    description: "近日有媒体拍到某知名男艺人与一位神秘女子深夜同回住所，举止亲密引发热议。据目击者称两人在餐厅用餐两小时后一同离开...",
    thumbnail: "https://readdy.ai/api/search-image?query=dark%20street%20night%20scene%20with%20paparazzi%20flash%20photography%20style%2C%20two%20figures%20walking%20together%20under%20street%20lamps%2C%20cinematic%20moody%20lighting%2C%20celebrity%20gossip%20vibe%2C%20warm%20orange%20streetlight%20glow%2C%20mysterious%20atmosphere%2C%20professional%20photojournalism%20aesthetic&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    category: "entertainment",
    views: 1283500,
    date: "2026-08-03",
    duration: "05:32",
    content: "",
    tags: ["明星", "恋情", "偷拍"],
    featured: true,
  },
  {
    id: "v2",
    title: "某网红直播翻车现场，千万粉丝围观尴尬瞬间",
    slug: "influencer-live-fail",
    description: "拥有千万粉丝的知名网红在昨晚直播中意外翻车，原本精心准备的产品推荐环节因设备故障导致画面卡顿，随后又因口误引发争议...",
    thumbnail: "https://readdy.ai/api/search-image?query=streaming%20studio%20setup%20with%20ring%20light%20and%20camera%2C%20frustrated%20expression%2C%20modern%20minimalist%20room%2C%20bright%20warm%20lighting%2C%20live%20stream%20equipment%2C%20professional%20photography&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    category: "hot",
    views: 2356000,
    date: "2026-08-03",
    duration: "08:15",
    content: "",
    tags: ["网红", "直播", "翻车"],
    featured: true,
  },
  {
    id: "v3",
    title: "某综艺节目录制现场突发意外，全场哗然",
    slug: "variety-show-accident",
    description: "在最新一期的热门综艺录制现场，一位嘉宾在游戏环节中不慎摔倒，导致录制一度中断。现场工作人员迅速上前查看情况...",
    thumbnail: "https://readdy.ai/api/search-image?query=variety%20show%20stage%20with%20colorful%20lighting%20and%20audience%20seats%2C%20dramatic%20moment%2C%20bright%20stage%20lights%2C%20entertainment%20production%20scene%2C%20professional%20broadcast%20setup&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    category: "entertainment",
    views: 876200,
    date: "2026-08-02",
    duration: "04:48",
    content: "",
    tags: ["综艺", "意外", "录制"],
    featured: true,
  },
  {
    id: "v4",
    title: "某企业高管内部邮件泄露，内容震撼业界",
    slug: "executive-leaked-email",
    description: "一封来自某知名科技企业高管的内部邮件昨日在社交平台疯传，邮件中涉及公司即将进行的大规模架构调整和裁员计划...",
    thumbnail: "https://readdy.ai/api/search-image?query=modern%20office%20corridor%20with%20glass%20walls%2C%20dramatic%20lighting%20from%20windows%2C%20corporate%20environment%2C%20professional%20atmosphere%2C%20warm%20interior%20design%2C%20business%20setting&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    category: "social",
    views: 1563000,
    date: "2026-08-02",
    duration: "06:20",
    content: "",
    tags: ["企业", "邮件", "泄露"],
    featured: true,
  },
  {
    id: "v5",
    title: "明星夫妇被曝婚变，双方工作室火速回应",
    slug: "celebrity-divorce-rumors",
    description: "娱乐圈又一对明星夫妻被曝婚姻出现危机。据知情人透露，两人已分居多时，各自忙于工作聚少离多，婚姻名存实亡...",
    thumbnail: "https://readdy.ai/api/search-image?query=luxury%20apartment%20living%20room%20with%20dim%20lighting%2C%20two%20separate%20suitcases%2C%20emotional%20atmosphere%2C%20warm%20evening%20light%20through%20curtains%2C%20cinematic%20mood%2C%20relationship%20drama%20theme&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    category: "entertainment",
    views: 1987000,
    date: "2026-08-01",
    duration: "07:42",
    content: "",
    tags: ["明星", "婚变", "回应"],
    featured: false,
  },
  {
    id: "v6",
    title: "某网红城市街头发生感人一幕，路人纷纷落泪",
    slug: "touching-street-scene",
    description: "在繁华的商业街头，一位老人突然晕倒在地，路人纷纷伸出援手。一位年轻女孩甚至毫不犹豫地脱下外套为老人垫在头下...",
    thumbnail: "https://readdy.ai/api/search-image?query=busy%20city%20street%20during%20daytime%2C%20people%20gathered%20around%2C%20warm%20sunlight%2C%20touching%20moment%2C%20urban%20compassion%20scene%2C%20natural%20light%2C%20documentary%20style%20photography&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    category: "social",
    views: 923400,
    date: "2026-08-01",
    duration: "04:15",
    content: "",
    tags: ["感人", "街头", "正能量"],
    featured: false,
  },
  {
    id: "v7",
    title: "某女星红毯造型引争议，设计师连夜发声明",
    slug: "red-carpet-controversy",
    description: "在某大型颁奖典礼的红毯环节，一位女星的奇特造型成为全场焦点。有网友调侃称该造型像'行走的盆栽'，引发热议...",
    thumbnail: "https://readdy.ai/api/search-image?query=red%20carpet%20event%20with%20flashing%20cameras%2C%20glamorous%20fashion%20moment%2C%20elegant%20venue%20background%2C%20warm%20golden%20lighting%2C%20celebrity%20fashion%20scene%2C%20luxurious%20atmosphere&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    category: "entertainment",
    views: 1678000,
    date: "2026-07-31",
    duration: "03:58",
    content: "",
    tags: ["红毯", "造型", "争议"],
    featured: false,
  },
  {
    id: "v8",
    title: "某品牌发布会现场大咖云集，神秘新品终曝光",
    slug: "brand-launch-event",
    description: "某国际知名品牌昨日举办年度新品发布会，现场星光熠熠，多位顶流明星到场助阵。最令人期待的神秘新品也在发布会尾声揭晓...",
    thumbnail: "https://readdy.ai/api/search-image?query=product%20launch%20event%20stage%20with%20large%20LED%20screen%2C%20spotlight%20effects%2C%20excited%20audience%2C%20modern%20conference%20hall%2C%20warm%20dramatic%20lighting%2C%20corporate%20event%20photography&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    category: "social",
    views: 1123000,
    date: "2026-07-31",
    duration: "09:10",
    content: "",
    tags: ["品牌", "发布会", "明星"],
    featured: false,
  },
  {
    id: "v9",
    title: "情侣街头吵架被拍，男方举动让网友炸锅",
    slug: "couple-street-fight",
    description: "一段情侣街头争吵的视频在社交平台疯传。视频中男子情绪激动，当众对女友大声呵斥，甚至摔砸手机，引发网友热议...",
    thumbnail: "https://readdy.ai/api/search-image?query=urban%20street%20corner%20during%20sunset%2C%20two%20people%20arguing%2C%20dramatic%20shadows%2C%20warm%20golden%20hour%20light%2C%20emotional%20confrontation%2C%20city%20background%2C%20documentary%20style&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    category: "emotion",
    views: 2145000,
    date: "2026-07-30",
    duration: "02:55",
    content: "",
    tags: ["情侣", "吵架", "街头"],
    featured: false,
  },
  {
    id: "v10",
    title: "宠物猫咪学会开门神技，主人回家瞬间惊呆",
    slug: "cat-opens-door",
    description: "一只聪明的橘猫被监控拍下独自在家时跳上门把手，用体重压下把手成功开门的画面。主人调取监控时笑到不行...",
    thumbnail: "https://readdy.ai/api/search-image?query=orange%20cat%20jumping%20on%20door%20handle%20in%20bright%20apartment%2C%20warm%20sunlight%20through%20window%2C%20funny%20pet%20moment%2C%20cozy%20home%20interior%2C%20clean%20minimal%20decor%2C%20natural%20lighting&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    category: "funny",
    views: 3456000,
    date: "2026-07-30",
    duration: "01:48",
    content: "",
    tags: ["宠物", "猫咪", "搞笑"],
    featured: false,
  },
  {
    id: "v11",
    title: "某楼盘开盘现场人山人海，排队三小时抢不到房",
    slug: "real-estate-craze",
    description: "某城市热门楼盘开盘当天，售楼处门前凌晨便排起长龙。有购房者表示排了三个小时仍未拿到号，场面十分火爆...",
    thumbnail: "https://readdy.ai/api/search-image?query=large%20crowd%20queuing%20outside%20modern%20building%20entrance%2C%20morning%20sunlight%2C%20urban%20scene%2C%20real%20estate%20sales%20office%2C%20warm%20atmospheric%20lighting%2C%20documentary%20style&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    category: "social",
    views: 987600,
    date: "2026-07-29",
    duration: "05:55",
    content: "",
    tags: ["房产", "排队", "火爆"],
    featured: false,
  },
  {
    id: "v12",
    title: "某知名导演新片选角内幕曝光，争议不断",
    slug: "director-casting-drama",
    description: "据业内人士透露，某知名导演的新片选角过程并不简单。多位一线演员参与了试镜，最终人选的决定背后另有隐情...",
    thumbnail: "https://readdy.ai/api/search-image?query=film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20cinematic%20glow%2C%20movie%20production%20scene%2C%20professional%20filmmaking&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    category: "entertainment",
    views: 1432000,
    date: "2026-07-29",
    duration: "06:38",
    content: "",
    tags: ["电影", "选角", "内幕"],
    featured: false,
  },
  {
    id: "v13",
    title: "小伙花光积蓄买豪车，提车当天的一幕令人唏嘘",
    slug: "luxury-car-regret",
    description: "一位年轻小伙为购买心仪已久的豪车花光了所有积蓄，然而提车当天在4S店门口发生的一幕却让他后悔不已...",
    thumbnail: "https://readdy.ai/api/search-image?query=luxury%20car%20dealership%20showroom%20with%20shiny%20new%20vehicle%2C%20bright%20modern%20interior%2C%20excited%20young%20man%2C%20warm%20showroom%20lighting%2C%20automotive%20photography%2C%20clean%20professional%20setting&width=640&height=360&seq=video-thumb-13&orientation=landscape",
    category: "emotion",
    views: 1894000,
    date: "2026-07-28",
    duration: "06:12",
    content: "",
    tags: ["豪车", "消费", "唏嘘"],
    featured: false,
  },
  {
    id: "v14",
    title: "某高校食堂推出奇葩新菜，学生排队抢购",
    slug: "college-weird-dish",
    description: "某高校食堂近日推出了一道名为'草莓炒黄瓜'的创新菜品，本以为会遭到学生吐槽，不料竟成为爆款，每天限量供应...",
    thumbnail: "https://readdy.ai/api/search-image?query=university%20cafeteria%20with%20students%20queuing%2C%20colorful%20food%20display%2C%20bright%20interior%20lighting%2C%20modern%20dining%20hall%2C%20warm%20atmosphere%2C%20lifestyle%20photography&width=640&height=360&seq=video-thumb-14&orientation=landscape",
    category: "funny",
    views: 2567000,
    date: "2026-07-28",
    duration: "02:34",
    content: "",
    tags: ["食堂", "奇葩", "美食"],
    featured: false,
  },
  {
    id: "v15",
    title: "外星人真的存在？某地夜空出现不明发光体",
    slug: "ufo-sighting",
    description: "某地多位市民在夜间目击到天空中出现了不明发光体，该物体在空中悬浮约十分钟后突然消失，引发网友对UFO的热烈讨论...",
    thumbnail: "https://readdy.ai/api/search-image?query=night%20sky%20with%20mysterious%20glowing%20orb%2C%20stars%20in%20background%2C%20dark%20landscape%20silhouette%2C%20mysterious%20atmosphere%2C%20warm%20orange%20glow%20on%20horizon%2C%20amateur%20astrophotography&width=640&height=360&seq=video-thumb-15&orientation=landscape",
    category: "bizarre",
    views: 4123000,
    date: "2026-07-27",
    duration: "04:22",
    content: "",
    tags: ["UFO", "夜空", "不明物体"],
    featured: false,
  },
  {
    id: "v16",
    title: "某国际巨星被拍到低调现身中国小城，原因感人",
    slug: "star-visits-small-town",
    description: "一位享誉国际的巨星近日被拍到低调现身中国某小城，既没有保镖也没有助理随行。而他此行的真正原因令人动容...",
    thumbnail: "https://readdy.ai/api/search-image?query=peaceful%20chinese%20small%20town%20street%20with%20traditional%20architecture%2C%20warm%20afternoon%20sunlight%2C%20quiet%20atmosphere%2C%20cultural%20setting%2C%20natural%20light%20through%20trees%2C%20travel%20photography&width=640&height=360&seq=video-thumb-16&orientation=landscape",
    category: "entertainment",
    views: 2891000,
    date: "2026-07-27",
    duration: "07:15",
    content: "",
    tags: ["巨星", "小城", "感人"],
    featured: false,
  },
];